module.exports = __webpack_public_path__ + "static/media/headwear.5ea0349e.png";